/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import {
  Drawer,
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  Card,
  Radio,
  Tooltip,
  AutoComplete,
} from "antd";
import React, { useState, useEffect } from "react";
import {
  checkNumbervalue,
  firstLetterCapitaliseDropDown,
} from "../../../../utils";
import useClientAndDepartment from "../useClientAndDepartment ";

import "./style.scss";
import AutoCompleteAddress from "../AutoCompleteAddress";

function ReturnAddressDrawer({
  open,
  setOpen,
  // clientID,
  alertData,
  changeSenderAddress,
  senderAddress,
  savedReturnAddressList,
  updateReturnAddressList,
  radioActive,
  upDateRadioActive,
  pincodeOptions,
  handlePincodeSearch,
  returnAddressform,
}) {
  const [size, setSize] = useState("large");
  const [dropDownChanges, setdropDownChanges] = useState(false);

  //  RESET after booking
  // useEffect(() => {
  //   if (alertData?.visible) {
  //     returnAddressform.resetFields([]);
  //   }
  // }, [alertData]);

  const { userInfo } =
    JSON.parse(window?.localStorage?.getItem("userId")) || "";
  const {
    returnPinCodeServiceableStatus,
    getReturnDeliveryPincode,
    areaList,
    resetCredit,
    handleOnEnter,
  } = useClientAndDepartment(userInfo, returnAddressform, "returnAddressform");

  const onClose = () => {
    setOpen(false);
  };
  const onSubmitFormData = (value) => {
    const newVal = {
      ...value,
      isAddressEnabled: 0,
    };

    const newAddress = [...savedReturnAddressList, newVal];
    updateReturnAddressList(newAddress);
    returnAddressform.resetFields();
    resetCredit();
  };

  useEffect(() => {
    const resetActiveState = () => {
      document.querySelectorAll(".ant-select-item-option").forEach((option) => {
        option.classList.remove("ant-select-item-option-active");
      });
    };

    const handleTabPress = (event) => {
      if (event.key === "Tab" || event.key === "Enter") {
        resetActiveState();
      }
    };

    document.addEventListener("keydown", handleTabPress);

    return () => {
      document.removeEventListener("keydown", handleTabPress);
    };
  }, [dropDownChanges]);

  const handleKeyDown = (event, dataOptions, formItemName) => {
    // console.log(event.key, "key");
    switch (event.key) {
      case "Enter":
        setdropDownChanges(!dropDownChanges);
        handleOnEnter(event);
        break;

      case "Tab":
        setdropDownChanges(!dropDownChanges);
        // eslint-disable-next-line no-case-declarations
        let activeOption = document.querySelector(
          ".ant-select-item-option-active"
        );

        if (activeOption) {
          const value = activeOption.getAttribute("title");

          const optionExists = dataOptions?.some(
            (option) => option?.value?.toLowerCase() == value?.toLowerCase()
          );
          if (optionExists) {
            returnAddressform.setFieldsValue({ [formItemName]: value });
          }
        }

        break;

      default:
        break;
    }
  };

  return (
    <div>
      <Drawer
        className="credit-custom-styled-drawer"
        title={"Add Return Address"}
        placement="right"
        size={size}
        onClose={onClose}
        open={open}
      >
        <div style={{ padding: "5px 20px" }}>
          <Form
            //   {...formProps}
            form={returnAddressform}
            onFinish={onSubmitFormData}
            layout="vertical"
            className="global-form"
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
          >
            <Row className="global-form-row" gutter={20}>
              <Col lg={12}>
                <Form.Item
                  name="returnPincode"
                  label="To Pincode"
                  className="pincode"
                  validateStatus={returnPinCodeServiceableStatus?.status}
                  help={returnPinCodeServiceableStatus?.msg}
                  rules={[
                    {
                      required: true,
                      message: "Enter pincode",
                    },
                    () => ({
                      validator(rule, value = "") {
                        if (value?.length > 0 && value?.length < 6) {
                          return Promise.reject("Pincode should be 6 digits");
                        } else {
                          return Promise.resolve();
                        }
                      },
                    }),
                  ]}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleOnEnter(event);
                    } else if (checkNumbervalue(event)) {
                      event.preventDefault();
                    }
                  }}
                >
                  <AutoComplete
                    // options={options}
                    onSearch={handlePincodeSearch}
                    options={pincodeOptions?.map((option) => ({
                      ...option,
                    }))}
                    // onDropdownVisibleChange={handleDropdownOpen}
                    onSelect={(value, obj) => {
                      getReturnDeliveryPincode(value, "returnPincode");
                    }}
                    onFocus={() => setdropDownChanges(!dropDownChanges)}
                    maxLength={6}
                    onKeyDown={(event) => {
                      // setActivePinOption(null);
                      handleKeyDown(
                        event,
                        pincodeOptions,
                        "returnPincode",
                        "value"
                      );
                    }}
                  >
                    <Input
                      onChange={(e) => {
                        if (e.target.value?.length == 6) {
                          getReturnDeliveryPincode(
                            e?.target?.value,
                            "returnPincode"
                          );
                        }
                      }}
                      placeholder="Enter return pincode"
                      suffix={
                        <span
                          className={
                            returnPinCodeServiceableStatus?.serviceability ===
                            "Regular"
                              ? "green"
                              : returnPinCodeServiceableStatus?.serviceability ===
                                "Premium"
                              ? "orange"
                              : "red"
                          }
                        >
                          {returnPinCodeServiceableStatus?.stateCode}
                        </span>
                      }
                    />
                  </AutoComplete>
                </Form.Item>
              </Col>
              <Col lg={12}>
                {/* <Form.Item
                  lg={6}
                  sm={6}
                  label="Area"
                  type="select"
                  name="returnAreaName"
                  placeholder="Search area"
                  rules={[
                    {
                      required: false,
                      message: "Select area",
                    },
                  ]}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleOnEnter(event);
                    }
                  }}
                >
                  <Select
                    showSearch
                    defaultActiveFirstOption={true}
                    showAction={["focus", "click"]}
                    placeholder="Select area"
                    // options={areaList}
                    // filterOption={(input, option) =>
                    //   (option?.label ?? "")
                    //     .toLowerCase()
                    //     .includes(input.toLowerCase())
                    // }
                    onKeyDown={(event) =>
                      handleKeyDown(event, areaList, "returnAreaName", "value")
                    }
                  >
                    {areaList?.map((item) => (
                      <Select.Option
                        key={item?.value}
                        id={item?.value}
                        spid={item?.spId}
                        value={item?.label}
                        // disabled={item?.disabled}
                      >
                        {item?.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item> */}
              </Col>
              <Col lg={12} sm={12}>
                <Form.Item
                  label="Name"
                  name="returnName"
                  rules={[
                    {
                      required: true,
                      message: "Enter name",
                    },
                  ]}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleOnEnter(event);
                    }
                  }}
                >
                  <Input
                    placeholder="Enter name"
                    onInput={(e) =>
                      (e.target.value = e?.target?.value?.toUpperCase() || "")
                    }
                    maxLength={40}
                  />
                </Form.Item>
              </Col>
              <Col lg={12} sm={12}>
                <Form.Item
                  label="Address"
                  name="returnAddressLine1"
                  rules={[
                    {
                      required: true,
                      message: null,
                    },
                  ]}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleOnEnter(event);
                    }
                  }}
                >
                  <AutoCompleteAddress
                    returnAddress={true}
                    form={returnAddressform}
                    addressDetailsCallback={null}
                    fieldName="returnAddressLine1"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Mobile number"
                  name="returnMobileNumber"
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleOnEnter(event);
                    }
                  }}
                  rules={[
                    () => ({
                      validator(rule, value = "") {
                        if (value?.length > 0 && value?.length < 10) {
                          return Promise.reject(
                            "Please enter 10 digits phone number"
                          );
                        } else if (parseInt(value?.substring(1, 0)) === 0) {
                          return Promise.reject(
                            "Mobile number should not be 0"
                          );
                        } else {
                          return Promise.resolve();
                        }
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="Enter phone number"
                    onKeyPress={(e) => {
                      if (/[^0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Email address"
                  name="returnEmail"
                  rules={[
                    {
                      type: "email",
                      message: "Give the correct email",
                    },
                  ]}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      handleOnEnter(event);
                    }
                  }}
                >
                  <Input
                    placeholder="Enter email address"
                    maxLength={40}
                    onBlur={(e) =>
                      returnAddressform.setFieldValue(
                        "returnEmail",
                        e?.target?.value?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Button
            className="save-btn"
            onClick={returnAddressform.submit}
            id="submit_drawer"
            // htmlType="submit"
          >
            Add +{" "}
          </Button>
          <div className="pt-1  ">
            <div>
              <div
                className="pointer"
                onClick={() => upDateRadioActive("default")}
              >
                <Card
                  key={"add"}
                  size="small"
                  title={
                    <span>
                      <Radio
                        onChange={() => upDateRadioActive("default")}
                        checked={radioActive === "default"}
                      ></Radio>
                      {senderAddress?.senderName}
                    </span>
                  }
                  style={{
                    width: "auto",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    marginBottom: "1rem",
                    padding: "0",
                    borderRadius: "5px",
                    border:
                      radioActive === "default"
                        ? "2px dashed #D7D9E8"
                        : "2px dashed #DCDDE0",
                    background:
                      radioActive === "default" ? "#F4F8FF" : "#FFFFFF",
                  }}
                >
                  <p style={{ marginTop: "-0.5rem" }}>
                    {senderAddress?.senderAddressLine1}
                  </p>
                  <p style={{ marginTop: "-1rem" }}>
                    {senderAddress?.areaName}, -{senderAddress?.senderPincode}
                  </p>
                  <p style={{ marginTop: "-1rem" }}>
                    {senderAddress?.senderMobileNumber}
                  </p>
                  <p style={{ marginTop: "-1rem" }}>
                    {senderAddress?.senderEmail}
                  </p>
                </Card>
              </div>
              {savedReturnAddressList?.map((e, i) => (
                <div
                  key={i}
                  className="pointer"
                  onClick={() => upDateRadioActive(i)}
                >
                  <Card
                    key={`add${i}`}
                    size="small"
                    title={
                      <span>
                        <Radio
                          onChange={() => upDateRadioActive(i)}
                          checked={i === radioActive}
                        ></Radio>
                        {e?.returnName}
                      </span>
                    }
                    style={{
                      width: "auto",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                      marginBottom: "1rem",
                      padding: "0",
                      borderRadius: "5px",
                      border:
                        i === radioActive
                          ? "2px dashed #D7D9E8"
                          : "2px dashed #DCDDE0",
                      background: i === radioActive ? "#F4F8FF" : "#FFFFFF",
                    }}
                  >
                    <p style={{ marginTop: "-0.5rem" }}>
                      {e?.returnAddressLine1}
                    </p>
                    <p style={{ marginTop: "-1rem" }}>
                      {/* {e.returnAreaName}, -{e?.returnPincode} */}
                      {e?.returnPincode}
                    </p>
                    <p style={{ marginTop: "-1rem" }}>
                      {e?.returnMobileNumber}
                    </p>
                    <p style={{ marginTop: "-1rem" }}>{e?.returnEmail}</p>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default ReturnAddressDrawer;
